export const GET_ALL_OPERATORS_WITH_NODES_REQUEST =
  " GET_ALL_OPERATORS_WITH_NODES_REQUEST";
export const GET_ALL_OPERATORS_WITH_NODES_SUCCESS =
  " GET_ALL_OPERATORS_WITH_NODES_SUCCESS";
export const GET_ALL_OPERATORS_WITH_NODES_FAILURE =
  " GET_ALL_OPERATORS_WITH_NODES_FAILURE";
